import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=de9b9f76&"
import script from "./settings.vue?vue&type=script&lang=ts&"
export * from "./settings.vue?vue&type=script&lang=ts&"
import style0 from "./settings.vue?vue&type=style&index=0&id=de9b9f76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports